/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const RoyaltyStatus = {
    CREATED: 'CREATED',
    PAID: 'PAID',
    EXEMPT: 'EXEMPT',
    NOT_LOADED: 'NOT_LOADED'
} as const;
export type RoyaltyStatus = typeof RoyaltyStatus[keyof typeof RoyaltyStatus];

